// extracted by mini-css-extract-plugin
export var addressFields = "_n5-0";
export var animationContainer = "_n5-1";
export var footer = "_n5-2";
export var lineItems = "_n5-3";
export var modalContent = "_n5-4";
export var orderName = "_n5-5";
export var strong = "_n5-6";
export var warning = "_n5-7";